// Wait for full window load so we don't miss any elements that open the original modal
window.addEventListener('load', () => {
	// Try to get store AutoOps API key
	let txtAutoOpsApiKey = null
	if (JSON.parse(localStorage.vuex).location.selectedStore != null) {
		txtAutoOpsApiKey = JSON.parse(localStorage.vuex).location.selectedStore.txtAutoOpsApiKey
	}
	// Check for store AutoOps API key amd do stuff
	if (txtAutoOpsApiKey) {
		// Create AutoOps script with store API key
		let autoOpsScript = document.createElement('script')
		autoOpsScript.id = 'portal-scripts'
		autoOpsScript.src = 'https://portal.autoops.com/portal-scripts.js'
		autoOpsScript.dataset.loadingColor = 'c30014'
		autoOpsScript.dataset.googleAnalyticsEnabled = 'true'
		autoOpsScript.dataset.apiKey = txtAutoOpsApiKey
		// Append and load the created script
		document.head.appendChild(autoOpsScript)

		// Do stuff once the script loads
		autoOpsScript.addEventListener('load', () => {

			function prefillAutoOps() {
				let service = null
				if (window.location.href.includes('/service/')) {
					service = window.location.href.split('/').at(-2).trim()
				}

				let tireCode = null
				if (window.location.href.includes('/tirequote/')) {
					tireCode = window.location.href.split('&product_code=')[1].split('=')[0].split('&')[0]
					service = 'tires'
				}

				let tires = null
				if (JSON.parse(localStorage.vuex).tires.listReq.req) {
					tires = JSON.parse(localStorage.vuex).tires.listReq.req.results.data
				}
				let sidePanel = {}
				let addtnlNotes = ''
				if (tireCode) {
					for (let tire of tires) {
						if (tireCode == tire.manufacturerproductcode) {
							sidePanel.imageCaption = tire.brand
							sidePanel.imageUrl = `${window.location.protocol}//${window.location.hostname}${tire.mainImage}`
							sidePanel.title = tire.model
							sidePanel.description = `${tire.size} ${tire.treadTypeTranslation}`
							addtnlNotes = `Qty: ${tire.selected_quantity} || ${tire.brand} ${tire.model} || ${tire.rawsize} || ${tire.tireload}${tire.tirespeed} || ${tire.treadTypeTranslation}`
						}
					}
					AutoOps.show(
						{
							prefill: {
								additionalNotes: addtnlNotes,
								issues: [
									{ "key": service },
								],
							},
							settings: { sidePanel }
						}
					)
				} else {
					AutoOps.show(
						{
							prefill: {
								issues: [
									{ "key": service },
								],
							}
						}
					)
				}
			}
			// Vue hook
			window.autoOpsShow = prefillAutoOps;
			
			let requestAppt = null
			if (document.querySelector('#request-appt')) {
				requestAppt = document.querySelector('#request-appt')
			}
			let scheduleModalBtn = null
			if (document.querySelectorAll('[data-open="scheduleModal"]')) {
				scheduleModalBtn = document.querySelectorAll('[data-open="scheduleModal"]')
			}

			if (requestAppt) {
				requestAppt.addEventListener('click', () => {
					prefillAutoOps()
				})
			}

			if (scheduleModalBtn) {
				scheduleModalBtn.forEach((el) => {
					delete el.dataset.open
					el.addEventListener('click', () => {
						prefillAutoOps()
					})
				})
			}
		})
	} else {
		const requestAppt = null
		if (document.querySelector('#request-appt')) {
			requestAppt = document.querySelector('#request-appt')
			requestAppt.addEventListener('click', () => {
				document.querySelector('#scheduleModal').foundation('open')
			})
		}
	}
})